
import {
    defineComponent,
    onMounted
} from "vue";
export default defineComponent({
    name: "CigoLayerMask",
    setup(props, ctx) {
        const click = () => {
            ctx.emit("clickMask");
        };

        return {
            click
        };
    }
});
